import http from './http';
import settings from './settings';

export default new class RequestStarter {

  async start({
    clientSid,
    shortDescription,
    processSid,
    processName,
    copiedParentSid,
    commonLib,
    byPassStart,
    parentInstanceSid
  }) {
    const isPreviewableResult = await http.get(`${settings.nodeRoot}/processes/${processSid}/ispreviewable/`)
    let isPreviewable = isPreviewableResult.data

    // get the first task in the request without creating a request
    let instanceToInspect;
    try {
      const coreServiceClient = await commonLib.serviceClient.getClient("core-service");
      const response = await coreServiceClient.apis.Request.Inspect({process_sid: processSid});

      instanceToInspect = response.body;
    } catch (error) {
      console.log("error inspecting instance", error);
    }

    // get the process task recipients of the first task in the request
    let processTaskRecipients;
    try {
      const processClient = await commonLib.serviceClient.getClient("processes");
      const response =
        await processClient.apis.processTaskRecipients.listProcessTaskRecipients(
          { processTaskSid: instanceToInspect.BaseTask.SID }
        );

      processTaskRecipients = response.body;
    } catch (error) {
      console.log("error getting process task recipients", error);
    }

    if (instanceToInspect && processTaskRecipients) {
      const recipientProcessing = instanceToInspect.BaseTask.RecipientProcessing;

      // if the recipient of the first task is client, but no client was supplied, do not create request
      if (
        (recipientProcessing === "Single" ||
          (recipientProcessing === "Sequential" && !clientSid)) &&
        processTaskRecipients.results &&
        processTaskRecipients.results.length &&
        processTaskRecipients.results[0].name &&
        processTaskRecipients.results[0].name === "Client"
      ) {
        isPreviewable = true;
      }
    }

    if (isPreviewable) {
      const currentStorageItem = localStorage.getItem('ngStorage-request_preview');
      let cleanData = [];
      if(currentStorageItem){
        const item = typeof currentStorageItem === 'string' ? JSON.parse(currentStorageItem) : currentStorageItem;
        if(!Array.isArray(item)){
          cleanData.push(item);
        }else cleanData = item;
      }
      const previewResult = await http.get(`${settings.coreRoot}/request/${processSid}/preview/`)
      const preview = previewResult.data
      cleanData.push(preview);

      localStorage.setItem('ngStorage-request_preview', JSON.stringify(cleanData))

      await this.navigateToFirstTask({
        processName: processName,
        taskName: preview.BaseTask.Name,
        recipientTaskSid: preview.SID,
        baseTaskSid: preview.BaseTask.SID,
        preview: true,
        shortDescription: shortDescription,
        clientSid: clientSid,
        copiedParentSid: copiedParentSid,
        byPassStart
      })
    } else {
      return await this._start(clientSid, shortDescription, processSid, byPassStart, parentInstanceSid);
    }    
  }

  // do not call directly, only from start
  async _start(clientSid, requestName, processSid, byPassStart, parentInstanceSid = null) {
    localStorage.removeItem('ngStorage-request_preview')

    const postData = [
      ["client_sid", clientSid],
      ["request_name", requestName],
      ["process_sid", processSid],
      ["parent_sid", parentInstanceSid],
      ["title", "New Request"],
      ["method", "GET"],
      ["datatype", "script"],
      ["oauth_required", true],
    ];

    const res = await http.post(`${settings.coreRoot}/request/start/`, postData)
    let result = res.data;
    if (result && result.NextTasks && result.NextTasks.length) {
      var nextTask = result.NextTasks[0];

      await this.navigateToFirstTask({
        recipientTaskSid: nextTask.SID,
        preview: false,
        instanceSid: result.SID,
        byPassStart,
      })
    } else {
      // send to req detail
      let url = `/workflow/angular/#/section-dashboard/request/${result.SID}`

      this.goToUrl(url, byPassStart)
    }
  }

  async navigateToFirstTask({processName, taskName, recipientTaskSid, baseTaskSid, preview, shortDescription,
    clientSid, copiedParentSid, instanceSid, byPassStart}) {
    let url
    if (preview) 
      url = `/workflow/actions/request/preview?recipientTaskSid=${recipientTaskSid}&requestName=${encodeURIComponent(shortDescription)}&processName=${processName}&copiedParentSid=${copiedParentSid}&clientSid=${clientSid || ''}&baseTaskSid=${baseTaskSid}`
    else
      url = `/workflow/actions/request/${instanceSid}?recipientTaskSid=${recipientTaskSid}`
    
    this.goToUrl(url, byPassStart)
  }

  goToUrl(url, byPassStart) {
    // if we bypassed the start request screen, use replaceState so the user can't go back it
    if (byPassStart) window.history.replaceState({}, '', url)
    else window.history.pushState({}, '', url)
  }
}